module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "P-P33"
  }), _vm._v(" "), _c('p', {
    staticClass: "P-P25"
  }), _vm._v(" "), _c('p', {
    staticClass: "P-P36"
  }, [_vm._v("September 2, 1944")]), _vm._v(" "), _c('p', {
    staticClass: "P-P30"
  }), _vm._v(" "), _c('p', {
    staticClass: "P-P30"
  }, [_vm._v("I suppose that I always knew, and that’s why there was no surprise. No, I think I acknowledged it in the past, never understanding what it would mean. It starts in my chest.")]), _vm._v(" "), _c('p', {
    staticClass: "P-P30"
  }), _vm._v(" "), _c('p', {
    staticClass: "P-P37"
  }, [_vm._v("Why are they being so nice?")]), _vm._v(" "), _c('p', {
    staticClass: "P-P30"
  }), _vm._v(" "), _c('p', {
    staticClass: "P-P30"
  }, [_vm._v("On the drive home from Memphis, everything was fine. Suddenly, they’re delicate with me, noticeably so.")]), _vm._v(" "), _c('p', {
    staticClass: "P-P30"
  }), _vm._v(" "), _c('p', {
    staticClass: "P-P37"
  }, [_vm._v("Yes, I’m different now, but I’m still me.")]), _vm._v(" "), _c('p', {
    staticClass: "P-P30"
  }), _vm._v(" "), _c('p', {
    staticClass: "P-P30"
  }, [_vm._v("And it cracks. A rift opens over my heart, spreading over my stomach, into my shoulders. Walking up the stairs as the sky darkens, carrying shopping bags, I tilt my head and I know.")]), _vm._v(" "), _c('p', {
    staticClass: "P-P30"
  }), _vm._v(" "), _c('p', {
    staticClass: "P-P30"
  }, [_c('span', {
    staticClass: "S-T1"
  }, [_vm._v("This isn’t how I thought it would be")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "P-P30"
  }), _vm._v(" "), _c('p', {
    staticClass: "P-P30"
  }, [_vm._v("I pictured falling, impassioned: dissolving. But everything is muted. I feel light as I walk into my room, placing the bags at the foot of the bed. Calm, I turn.")]), _vm._v(" "), _c('p', {
    staticClass: "P-P30"
  }), _vm._v(" "), _c('p', {
    staticClass: "P-P30"
  }, [_vm._v("“Give it to me. Give me the letter.”")]), _vm._v(" "), _c('p', {
    staticClass: "P-P30"
  }), _vm._v(" "), _c('p', {
    staticClass: "P-P30"
  }, [_vm._v("I had imagined snatching the paper, almost shredding it. Instead, my muscles constrict: the cracks increasing.")]), _vm._v(" "), _c('p', {
    staticClass: "P-P30"
  }), _vm._v(" "), _c('p', {
    staticClass: "P-P37"
  }, [_vm._v("Perhaps it was folly to think I could keep them both.")]), _vm._v(" "), _c('p', {
    staticClass: "P-P30"
  }), _vm._v(" "), _c('p', {
    staticClass: "P-P30"
  }, [_vm._v("They utter something but I don’t hear. I can’t even see the telegram as I finger for the envelope’s opening.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5e34d0c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0005.vue
// module id = 72
// module chunks = 0